import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import turbolinks from 'turbolinks';
import externalLinks from './components/external-links';
import gaMaps from './components/ga-maps';

require('jquery');
require('bootstrap');
require('slick-carousel');
require('./components/nav');
require('./components/hero');
require('./components/scroll-to');

turbolinks.start();

document.addEventListener('turbolinks:load', () => {
	externalLinks.init();
	gaMaps.init();
});



// WEBPACK FOOTER //
// ./src/js/app.js